export default __webpack_public_path__ + "static/media/discord.35c5a30d.svg";